import { GiftedChatMessage } from '../../../../components/DiscussionMessages/DiscussionMessagesComponent';
import React, { FC } from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import useStyles from './styles';

interface ICustomInputToolbarHeader {
  quotedMessage: GiftedChatMessage | undefined;
  onUnquoteMessage: () => void;
}

const CustomInputToolbarHeader: FC<ICustomInputToolbarHeader> = (props) => {
  const { quotedMessage, onUnquoteMessage } = props;
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Typography style={{ fontStyle: 'italic' }}>
        {quotedMessage?.text}
      </Typography>
      <IconButton onClick={() => onUnquoteMessage()}>
        <HighlightOffIcon />
      </IconButton>
    </Box>
  );
};

export default CustomInputToolbarHeader;
